import "assets/css/dashboard.css"
import "assets/css/terminals.css"
import { useEffect, useState } from "react"
import { fetchSummaryData, fetchLineData } from "components/Dashboard/helpers"
import InventoryReport from "components/Dashboard/InventoryReport"
import Summary from "components/Dashboard/Summary"
import BarCharts from "components/Dashboard/BarCharts"
import LineChart from "components/Dashboard/LineChart"
import HeatmapChart from "components/Dashboard/ordersHeatMap"
import { CardFrame } from "components/UI/CardFrame"
import MXBorderCrossKPIs from "components/Dashboard/borderCrossKPI"

const Dashboard = () => {
  const [summaryData, setSummaryData] = useState({})
  const [lineData, setLineData] = useState(null)

  const now = new Date()
  const oneMonthAgo = new Date(now)
  oneMonthAgo.setMonth(now.getMonth() - 1)

  useEffect(() => {
    fetchSummaryData(setSummaryData)
    fetchLineData(setLineData)
  }, [])

  return (
    <div className="main-container">
      <div>
        {/* Inventory summary table */}
        {summaryData.inventory_report && (
          <CardFrame title="Warehouse KPIs">
            <InventoryReport data={summaryData.inventory_report} />
          </CardFrame>
        )}
      </div>
      <div>
        {/* Per terminal buses and partials */}
        {summaryData.summary &&
          <Summary data={summaryData.summary} />}
      </div>
      <div className="row">
        {/* Orders overview */}
        <div className="col-lg-6 col-md-12">
          <CardFrame title="Order Count">
            <div className="p-0 m-0" style={{ height: "754px" }}>
              {lineData && <LineChart data={lineData} />}
            </div>
          </CardFrame>
          {/* {summaryData.summary &&
            <BarCharts data={summaryData.summary} />
          } */}
        </div>
        {/* Scheduled pickup heatmap */}
        <div className="col-lg-6 col-md-12">
          <HeatmapChart />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12">
          <MXBorderCrossKPIs />
        </div>
      </div>
    </div>
  )
}

export default Dashboard
